import React, { useState } from "react";
import {
  Dialog, DialogContent, DialogContentText, TextField, DialogActions
} from '@mui/material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import sendRequest from '../utils/sendRequest';
import { MenuButtonIcon, SubmitButton, CancelButton } from '../styled/CustomButtons';
import { CustomDialogTitle } from "../styled/DialogTitles";

export default function CalculateNetSalesDialog({
  po_doc_id, poName, addSnackbar,
  shippingFeeDefault = "", customsFeeDefault = "",
  otherFeeDefault = "",
  fetchPos = null, fetchPoDetails = null, isIcon
}) {
  const [loadingCalculate, setLoadingCalculate] = useState(false);
  const [open, setOpen] = useState(false);
  const [shippingFee, setShippingFee] = useState("");
  const [customsFee, setCustomsFee] = useState("");
  const [otherFee, setOtherFee] = useState("");

  const fetchAction = fetchPos ? fetchPos : fetchPoDetails;

  const fetchAdditionalFees = async () => {
    const data = await sendRequest(`purchase-orders/details?po_doc_id=${po_doc_id}`);
    const additional_fees = data.additional_fees;
    if (additional_fees) {
      setShippingFee(String(additional_fees.shipping_fees));
      setCustomsFee(String(additional_fees.customs_fees));
      setOtherFee(String(additional_fees.other_fees));
    }
  };

  const handleOpen = () => {
    setOpen(true);
    if (!isIcon) {
      setShippingFee(String(shippingFeeDefault));
      setCustomsFee(String(customsFeeDefault));
      setOtherFee(String(otherFeeDefault));
    } else {
      fetchAdditionalFees();
    }
  };

  const handleClose = () => {
    if (!loadingCalculate) {
      setOpen(false);
    }
  };

  const handleShippingFeeChange = (e) => {
    let value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) setShippingFee(value);
  }

  const handleCustomsFeeChange = (e) => {
    let value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) setCustomsFee(value);
  }

  const handleOtherFeeChange = (e) => {
    let value = e.target.value;
    if (value === "" || /^\d*\.?\d*$/.test(value)) setOtherFee(value);
  }

  const calculateNetSales = async (po_doc_id, fees) => {
    setLoadingCalculate(true);
    try {
      await sendRequest(`purchase-orders/calculate-net-sales?po_doc_id=${po_doc_id}`, fees, "POST");
      fetchAction();
      addSnackbar("Calculating Net Sales for PO");
    } catch (error) {
      addSnackbar(error.message, false);
    } finally {
      setLoadingCalculate(false);
      handleClose();
    }
  }

  return (
    <>
      <MenuButtonIcon
        isIcon={isIcon}
        title={"Calculate Projected Net Sales"}
        text={"Calculate Net Sales"}
        icon={MonetizationOnIcon}
        onClick={handleOpen}
      />
      <Dialog
        open={open}
        onClose={handleClose}
        disableEscapeKeyDown={loadingCalculate}
        PaperProps={{
          component: 'form',
          onSubmit: event => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries().map(
              ([key, value]) => [key, value === "" ? 0 : Number(value)]
            ));
            calculateNetSales(po_doc_id, formJson);
          },
          autoComplete: 'off',
        }}
      >
        <CustomDialogTitle
          header={"Additional Costs"}
          poName={poName}
        />
        <DialogContent>
          <DialogContentText>Please enter all additional costs that apply (USD).</DialogContentText>
          <TextField
            autoFocus
            required
            margin="dense"
            id="shipping_fees"
            name="shipping_fees"
            label="Shipping Fees"
            type="text"
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            fullWidth
            variant="standard"
            value={shippingFee}
            onChange={handleShippingFeeChange}
          />
          <TextField
            required
            margin="dense"
            id="customs_fees"
            name="customs_fees"
            label="Customs Fees"
            type="text"
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            fullWidth
            variant="standard"
            value={customsFee}
            onChange={handleCustomsFeeChange}
          />
          <TextField
            required
            margin="dense"
            id="other_fees"
            name="other_fees"
            label="Other Fees"
            type="text"
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            fullWidth
            variant="standard"
            value={otherFee}
            onChange={handleOtherFeeChange}
          />
          <div></div>
          <DialogContentText variant="h6">{`Total Fees: $${(Number(shippingFee) || 0) + (Number(customsFee) || 0) + (Number(otherFee) || 0)}`}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <CancelButton onClick={handleClose} disabled={loadingCalculate}>Cancel</CancelButton>
          <SubmitButton
            showSpinner={loadingCalculate}
            text={"Submit"}
            type="submit"
          />
        </DialogActions>
      </Dialog>
    </>
  )
}
